import React from 'react';

import {buildCatalogMap, getParents} from '../../lib/catalog';
import {default as CatalogInput2} from '../CatalogInput';

function MultiCatalogInput({id, label, catalog, values, onChange, invalid}) {
  const catalogById = buildCatalogMap(catalog);
  const itemIds = values.map(value => value.split(',')).map(values => values[values.length - 1]);

  return (
    <CatalogInput2
      id={id}
      multiple
      label={label}
      catalog={catalog}
      value={itemIds}
      onChange={itemIds => {
        const items = itemIds.map(itemId => {
          const item = catalogById[itemId];
          const parents = getParents(item, catalogById).reverse();

          return [...parents, item].map(item => item.id).join(',');
        });
        
        onChange(items, items.length > 0);
      }}
      invalid={invalid}
    />
  );
}

export default MultiCatalogInput;
